import React, {useState, useEffect}from 'react';
import {useTranslation} from "react-i18next";
import DaohuuLayoutComponent from '@app/pages/FUtil/DaohuuLayoutComponent';
import {Button, Modal} from "react-bootstrap";
import {myService} from '@app/services/sukienService';
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import LoaitailieuListComponent from '@app/pages/FUtil/LoaitailieuListComponent';
import TrangthaiListComponent from '@app/pages/FUtil/TrangthaiListComponent';
import {alertService} from '@app/services/alertService';
import {
    image_root, root_path, template_upload_root
} from "@app/const/AppSetting";
import './popupimage.css';
import {ClipLoader} from "react-spinners";
const TailieuEdit = ({id}) => {
    const [loading, setLoading] = useState(false);
    const [handleToogle, setHandleToogle] = useState(false);
    const [t] = useTranslation();
    const [tailieuList, setTailieuList] = useState([]);
    const initial = {
        ghi_chu:'',
        filetype : ''
    }
    const [isViewTailieu,setIsViewTailieu] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [obj, setObj] = useState({...initial});
    const [image, setImage] = useState(null); 
    const [preview, setPreview] = useState(null);

    const [isCreate, setIsCreate] = useState(false);
    

    const handleFileChange = (e) => { 
        const file = e.target.files[0];



        setImage(file); 
        setPreview(URL.createObjectURL(file));

        const ft = file.type.startsWith("image/")? 'image': 'other';
        const target = {name: "filetype", value:ft};
        onChangeInput({target});
    };
    
    const [imagePopup, setImagePopup] = useState(null); 

    const handleMouseEnter = (i) => {
        setIsCreate(false);
        setObj(tailieuList[i]);
        setPreview(tailieuList[i].image)
        setShowModal(true);
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
     }; 
    const handleMouseLeave = () => { setImagePopup(null); };
    const saveClick = async () => {
      
        let data = obj;
        if(!data)
        {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }
        if(!image)
        {
            alert('Vui lòng upload file');
            return;
        }

        create(data,image);

    };

     const loadRef = async () => {

             const tmp = await myService.getRefById(id,'sukien_tailieu',{});
             //const tmp = await myService.getRefById(1,10,{});
             setTailieuList(tmp);
             setIsViewTailieu(true);

           setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };
     const opendonhang = async (rowIndex) => {
            const { id } = tailieuList[rowIndex];
           
        };
    const onChangeInput =  (e) => {
        const {name, value, checked} = e.target;


        setObj((prevState) => ({
            ...prevState,
            [name]: value
        }));
        


    };

    async function create(data,fileUpload) {
            setLoading(true);
            // delete data.ma;
            const result = await myService.Create_Tailieu(id,fileUpload,data);
            
            if (result.status ==="1") {
                alertService.success(result.msg);
                
                await loadRef();
                setShowModal(false);
                setIsViewTailieu(true);
    
            } else {
                alertService.error(result.msg);
                handleFileChange(null);
            }
            setLoading(false);
        }

        
        
      
    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }
        
    return  <>
           

                                       
                            { isViewTailieu ? ( <Button 
                                className = "btn btn-secondary  mr-1" 
                            
                                aria-label="Close" 
                                onClick={() => { setIsViewTailieu(false); setTailieuList([]) ; setIsCreate(false); }}
                                >
                                <span aria-hidden="true">Ẩn</span>
                                </Button>) : (<Button className="btn btn-info  mr-1"  onClick={() => loadRef()}>
                                                <i className="fa fa-arrow-down"> {"Xem"}</i>
                                            </Button>
                                            )   

                            }
                            {
                                isViewTailieu && ( <Button
                                    className="btn  btn-success  mr-1"
                                    
                                    icon="right fas fa-angle-left"
                                    onClick={() => { setShowModal(true); setObj({...initial}); setPreview(null);setImage(null); setIsCreate(true); }}
                                >
                                <i className="fa fa-save"> {"Thêm"  } </i>
                                        </Button> )
                            }

                    {imagePopup && ( <div className="popup-image"> <img src={imagePopup} alt="Popup" /> </div> )}
                                    

                                <hr/>
                        { 
                            isViewTailieu &&
                            (<div className="row table-responsive">
                                <div className="col-md-12">
                                    <table responsive bordered hover className="table table-bordered table-hover text-nowrap">
                                        <thead>
                                        <tr>
                                            <th className="col-md-2 text-center">Tên file</th>
                                            <th className="col-md-2 text-center">Ghi chú</th>
                                            <th className="col-md-2 text-center">Thời gian tạo</th>
                                            <th className="col-md-2 text-center">Tác vụ</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {
                                            tailieuList && tailieuList.length > 0 &&  tailieuList.map((item, index) => {

                                                return (
                                                    <tr>
                                                        <td>
                                                            <div className="form-group">
                                                                <div className="form-control d-flex align-items-center">
                                                                    {item.ten}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="form-group">
                                                                <div className="form-control d-flex align-items-center">
                                                                    {item.ghi_chu}
                                                                </div>
                                                            </div>
                                                        </td>
                                                       
                                                      <td className="text-center">
                                                            <div className="form-group">
                                                            <div className="form-control d-flex align-items-center">
                                                            {item.ngay_tao}
                                                            </div>
                                                            </div>
                                                            </td>

                                                        <td className="text-center">
                                                            <a
                                                            onMouseEnter={() => handleMouseEnter(index) }
                                                                className="btn btn-secondary btn-sm mr-2"
                                                                key={`view-donhangcls-${index}`}
                                                                title={t('action.label.view')}
                                                                onClick={() => opendonhang(index)}>
                                                                <i className="fas fa-eye"></i>

                                                            </a>    
                                                        </td>
                                                        
                                                    </tr>
                                                );


                                            })

                                        }
                                        </tbody>
                                    </table>
                            </div>

                        </div>)
                        }
            <Modal size="lg" show={showModal} onHide={() => { setShowModal(false)}}>
                <Modal.Header>
                    <Modal.Title>
                       Tài liệu
                       </Modal.Title>
                </Modal.Header>
                <Modal.Body>


                    <div className="form-group">
                        <label >Ghi chú</label>
                        <input
                            type='text'
                            className="form-control"
                            name="ghi_chu"
                            id ="ghi_chu"
                            value={obj.ghi_chu}
                            onChange={(e) => onChangeInput( e)}
                        />
                    </div>

                     

                    {isCreate  &&(<div className='form-group'>
                        <label className="required"htmlFor="fileUpload">File upload</label>

                            <input id ='fileUpload' name ="fileUpload" type="file"  

                                accept= "*"
                                   className="form-control"  onChange={handleFileChange} />
                    
                    </div>   )}
                    {
                        obj.ngay_tao && (<div className='form-group'>
                            {obj.ngay_tao}
                        </div>   )
                     }   
                    <div className='form-group'>
                      {  preview &&  obj.filetype &&  obj.filetype === 'image' && <img style={{ maxHeight: '400px', maxWidth: '400px' }} src={preview} alt="Image Preview" />}
                      {  preview &&  obj.filetype && obj.filetype !== 'image' && <a href={preview} target="_blank" rel="noopener noreferrer"> Tài liệu đã upload </a>}
                    </div>            
                                    
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {setShowModal(false); }}>
                        {"Thoát"}
                    </Button>
                    {isCreate && (<Button variant="primary" onClick={saveClick}>
                        {"Xác nhận"}
                    </Button>)}
                    

                </Modal.Footer>
            </Modal>

                                       
       </>
};

export default TailieuEdit;
